var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar0(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.3 133.6H68.7l-44.4 88.1c-3.4 6.2-5.1 13.1-5.1 20.2v197.3c0 42.2 34.2 76.4 76.4 76.4H272c42.2 0 76.4-34.2 76.4-76.4V242.1c0-7.2-1.8-14.3-5.4-20.6l-46.7-87.9z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4 7.9h147c39.7 0 71.9 32.2 71.9 71.8v25.5c0 39.7-32.2 71.8-71.9 71.8h-147c-39.7 0-71.8-32.2-71.8-71.8V79.7c-.1-39.6 32.1-71.8 71.8-71.8z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9 2.6h171.6c32.9 0 59.5 26.7 59.5 59.5 0 32.9-26.7 59.5-59.5 59.5H93.9C61 121.7 34.3 95 34.3 62.1 34.3 29.3 61 2.6 93.9 2.6z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 424.2h235.7c25.8 0 46.7 20.9 46.7 46.7 0 25.8-20.9 46.7-46.7 46.7H65.9c-25.8 0-46.7-20.9-46.7-46.7 0-25.8 20.9-46.7 46.7-46.7z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 27.47,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 52.6h80.3c7.1 0 12.9 5.8 12.9 12.9v1.4c0 7.1-5.8 12.8-12.9 12.8H144c-7.1 0-12.9-5.8-12.9-12.8v-1.4c0-7.1 5.8-12.9 12.9-12.9z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.7 266.5v-24.4c0-7.2-1.8-14.3-5.4-20.6l-9-17M292.7 395.5v-81.4",
    stroke: "#FBFDFE",
    strokeWidth: 21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar0);
export default ForwardRef;